import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from '@mui/material';
import {styled} from '@mui/system';

import {autoPluralize} from '../../helpers/pluralizer';
import GrantListItem from './GrantListItem';
import PreviewAndAll from '../organism/PreviewAndAll';
import {PREVIEW_COUNT_S} from '../../settings';


const StyledGrants = styled('div')(({ theme }) =>({
    margin: 0,
    marginBottom: theme.custom.spacing.default
}));

const StyledGrantsList = styled('ul')(({ theme }) =>({
    paddingLeft: theme.custom.spacing.default,
    margin: 0
}));

const StyledListItem = styled('li')({
    margin: '0 0 5px 0',
    padding: 0
});


class GrantList extends React.Component {
    constructor(props) {
        super(props);
    }

    grantList = (grants) => {
        return (
            <div>
                {grants && <StyledGrantsList>
                    {grants.map((grant, index) =>
                        <StyledListItem key={index}>
                            <GrantListItem grant={grant} />
                        </StyledListItem>
                    )}
                </StyledGrantsList>}
            </div>
        );
    };

    render() {
        return (
            <StyledGrants>
                <Typography variant="subtitle2">
                    {autoPluralize(this.props.grants && this.props.grants.length || 0, 'Grant')}
                </Typography>
                <PreviewAndAll data={this.props.grants}
                               dataDisplayCallable={this.grantList}
                               previewCount={PREVIEW_COUNT_S} />
            </StyledGrants>
        );
    }

}

GrantList.propTypes = {
    grants: PropTypes.array
};

export default GrantList;
